<template>
	<div class="content_wrap">
		<div class="warp">
			<div class="register_main clearfix">
				<div class="register_main_top">
					<span class="second_font">机构开发者注册</span>
					<span class="register_user"><i class="content_font">已有账号?</i>
							<a class="content_link" href="#/login">立即登录</a>
						</span>
				</div>
				<div class="registe_item_box register_sumbit_box">
					<img src="../../assets/images/regist_step_ok.png" alt="" />
					<p class="third_font">您的申请提交成功！</p>
					<p class="summit_font">最终审批结果将于24小时之内通过短信和邮件的形式推送给您，请注意查收。</p>
				</div>

				<div class="register_btn_box">
					<a href="#/login" class="login_btn second_font">好的</a>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'thirdStep'
	}
</script>

<style lang="scss">
	.register_sumbit_box{
		padding-top: 80px;
		text-align: center;
		.third_font{
			height: 16px;
			line-height: 16px;
			margin: 18px 0;
		}
	}
	/*.step3 {
		background: url(../../assets/images/regist_step3.jpg) no-repeat;
		background-size: 100%;
	}*/
</style>


// WEBPACK FOOTER //
// src/components/_register/ThirdStep.vue